import { render, staticRenderFns } from "./SimpleLayout.vue?vue&type=template&id=50d618a4"
import script from "./SimpleLayout.vue?vue&type=script&lang=js"
export * from "./SimpleLayout.vue?vue&type=script&lang=js"
import style0 from "./SimpleLayout.vue?vue&type=style&index=0&id=50d618a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports